import jwtDecode from "jwt-decode"
import { DecodedAccessToken } from "models"
import browserStorageService, { STORAGE_KEY } from "services/browserStorage"

export const getAccessToken = () => {
    const config = JSON.parse(
        browserStorageService.get(STORAGE_KEY, { priority: "sessionStorage" })
    )
    return config ? config.token : null
}

// export const getMediaUrlPrefix = () => {
//     const accessToken = getAccessToken()
//     const decoded = jwtDecode(accessToken)
//     return `${decoded.region}/obikestore-documents-${decoded.region}/`
//     return false
// }

export const getEntityId = () => {
    const accessToken = getAccessToken()
    const decoded: DecodedAccessToken = jwtDecode(accessToken)
    return decoded.entity_id
}

export const getUserId = () => {
    const accessToken = getAccessToken()
    const decoded: DecodedAccessToken = jwtDecode(accessToken)
    return decoded.user_id
}

export const getOldStoreId = () => {
  const accessToken = getAccessToken()
  const decoded: DecodedAccessToken = jwtDecode(accessToken)
  return decoded.entity_old_store_id
}
